/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetConfig } from "../../sheets/types/SheetConfig";
import { FamilyId } from "../../commons/types/FamilyId";
import { MappingRuleConfig } from "./MappingRuleConfig";
export const ProgramConfig = core.serialization.object({
    source: SheetConfig,
    destination: SheetConfig,
    familyId: FamilyId.optional(),
    namespace: core.serialization.string().optional(),
    save: core.serialization.boolean().optional(),
    rules: core.serialization.list(MappingRuleConfig).optional(),
});
